import { render } from "./PaymentStatus.vue?vue&type=template&id=dbb42480&scoped=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&lang=js"

import "./PaymentStatus.vue?vue&type=style&index=0&id=dbb42480&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb42480"]])

export default __exports__